/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import CompanyRootElement from './style';
import { ProfileContextConsumer } from '../../../common/context/profile/context';
import AccordionList, { isItemAvailableInside } from '../../../common/accordionList';
import { COMPANY_INFORMATION_ACCORDION } from '../../../constants/app-constants';

const CompanyInformation = ({ profileDetails, loading }) => {
  const { companyInformation } = profileDetails || {};
  const { t } = useTranslation();
  let isValidItems = false;
  if (companyInformation) {
    isValidItems = Object.keys(companyInformation).map((item) => isItemAvailableInside(item, companyInformation)).includes(true);
  }
  return (
    <CompanyRootElement className="company-information">
      {isValidItems && (
        <Box className="page-container">
          <Typography variant="headline-small" mb={2} component="h3">{t('Company information')}</Typography>
          <AccordionList dataWatLoc="company information" items={companyInformation} loading={loading} size={COMPANY_INFORMATION_ACCORDION} />
        </Box>
      )}
    </CompanyRootElement>
  );
};

CompanyInformation.propTypes = {
  profileDetails: PropTypes.shape({}),
  loading: PropTypes.bool,
};
CompanyInformation.defaultProps = {
  profileDetails: {},
  loading: false,
};

export default ProfileContextConsumer(CompanyInformation);
